<template>
  <div>
    <div class="container lnb d_container">
      <div class="contents_wrap">
        <div class="contents list-container">
          <div class="title">Free-talking 관리</div>
          <div class="list-content content tab-content pb0">
            <div class="intro_tab active" @click="changeTab('freeTalk')">Free-talking 관리</div>
          </div>
          <div class="list-content">
            <online-firebase-component :isFreeTalk="'true'"></online-firebase-component>
          </div>
        </div>
        <div class="footer-copyright">Copyright 2021. Peopleandtalk co.,Ltd. All rights reserved</div>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from "@/utils/event-bus";
import OnlineFirebaseComponent from "@/components/online/OnlineFirebaseComponent";

export default {
  name: "FreeTalk",
  mixins: [],
  components: {
      OnlineFirebaseComponent
  },
  provide() {
    return {}
  },
  props: {},
  data() {
    return {
    }
  },
  created() {
  },
  mounted() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  computed: {},
  methods: {
    changeTab(tab) {
      // this.$router.push(`/content/${tab}`);
      // this.$nextTick(() => {
      //   this.$router.push(`/content/${tab}`);
      // })
    },
  },
  watch: {},
}
</script>

<style scoped>

</style>
